import React, { useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import intl from "react-intl-universal";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import YesIcon from "@material-ui/icons/CheckCircle";
import NoIcon from "@material-ui/icons/Cancel";
import KeepIcon from "@material-ui/icons/SwapHorizontalCircle";

import { IWithballData } from "apis";
import { EVENT_I18N_TAGS } from "modules/withball-data-input/constants";
import {
  getEventNameByValue,
  getEventCategoryByName,
} from "modules/withball-data-input/utils";
import {
  WITHBALL_DATA_STATUS,
  WITHBALL_DATA_CATEGORY_COLOR,
} from "MuiProvider";

import { EventListToolbar } from "./EventListToolbar";
import { EventListHeader } from "./EventListHeader";
import { IMiniUser } from "types";

interface IEventListProps {
  events: IWithballData[];
  players: IMiniUser[];
  onEventsPlay: (clips: number[]) => void;
}

type SelectIdMap = {
  [key: number]: boolean;
};

const backgroundAlpha = "20";

export const EventList = ({
  events,
  players,
  onEventsPlay,
}: IEventListProps) => {
  const [selectedIds, setSelectedIds] = useState<SelectIdMap>({});

  const handlePlayButtonClick = (eventId: number) => () => {
    onEventsPlay([eventId]);
  };

  const handleItemSelect = (eventId: number) => (event: any) => {
    selectedIds[eventId] = event.target.checked;
    setSelectedIds({ ...selectedIds });
  };

  const handleSelectAllClick = (event: any) => {
    if (event.target.checked) {
      const newSelectedIds: SelectIdMap = {};
      events.map((event) => {
        newSelectedIds[event.id] = true;
        return null;
      });
      setSelectedIds(newSelectedIds);
    } else {
      setSelectedIds({});
    }
  };

  const numSelected = Object.keys(selectedIds).reduce(
    (acc, cur: any) => acc + (selectedIds[cur] ? 1 : 0),
    0
  );

  const handleExportClick = () => {};

  const handlePlayClick = () => {
    const eventIds = Object.keys(selectedIds).reduce((acc, cur: any) => {
      if (selectedIds[cur]) {
        acc.push(parseInt(cur, 10));
      }
      return acc;
    }, [] as number[]);
    onEventsPlay(eventIds);
  };

  return (
    <>
      <EventListToolbar
        onExportClick={handleExportClick}
        onPlayClick={handlePlayClick}
        numSelected={numSelected}
      />
      <TableContainer>
        <Table
          aria-labelledby="tableTitle"
          //   size={dense ? "small" : "medium"}
          aria-label="enhanced table"
        >
          <EventListHeader onSelectAllClick={handleSelectAllClick} />
          <TableBody>
            {events.map((event, index) => {
              const isItemSelected = !!selectedIds[event.id];
              const labelId = `enhanced-table-checkbox-${index}`;
              const fromPlayer = players.find(
                (player) => player.id === event.fromPlayer
              );
              const toPlayer = players.find(
                (player) => player.id === event.toPlayer
              );
              let possessionIcon = null;
              switch (event.possession) {
                case "win":
                  possessionIcon = (
                    <IconButton style={{ color: WITHBALL_DATA_STATUS.win }}>
                      <YesIcon />
                    </IconButton>
                  );
                  break;
                case "lose":
                  possessionIcon = (
                    <IconButton style={{ color: WITHBALL_DATA_STATUS.lose }}>
                      <NoIcon />
                    </IconButton>
                  );
                  break;
                case "keep":
                  possessionIcon = (
                    <IconButton style={{ color: WITHBALL_DATA_STATUS.keep }}>
                      <KeepIcon />
                    </IconButton>
                  );
                  break;
                default:
                  possessionIcon = null;
              }
              const eventName = getEventNameByValue(event.action);
              const eventCategory = eventName
                ? getEventCategoryByName(eventName)
                : null;
              const background = eventCategory
                ? WITHBALL_DATA_CATEGORY_COLOR[eventCategory] + backgroundAlpha
                : "";
              return (
                <TableRow
                  hover
                  // onClick={(event) => handleClick(event, row.name)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={event.id}
                  selected={isItemSelected}
                  style={{
                    background,
                  }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected}
                      inputProps={{ "aria-labelledby": labelId }}
                      onChange={handleItemSelect(event.id)}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {intl.get(EVENT_I18N_TAGS[event.action])}
                  </TableCell>
                  <TableCell align="right">{fromPlayer?.name}</TableCell>
                  <TableCell align="right">{toPlayer?.name}</TableCell>
                  <TableCell align="right">
                    {event.succeed ? (
                      <IconButton style={{ color: WITHBALL_DATA_STATUS.win }}>
                        <YesIcon />
                      </IconButton>
                    ) : (
                      <IconButton style={{ color: WITHBALL_DATA_STATUS.lose }}>
                        <NoIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell align="right">{possessionIcon}</TableCell>
                  <TableCell align="right">
                    {new Date(event.created_at * 1000)
                      .toISOString()
                      .slice(11, 19)}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton onClick={handlePlayButtonClick(event.id)}>
                      <PlayCircleOutlineIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            {/* {emptyRows > 0 && (
              <TableRow>
                <TableCell colSpan={6} />
              </TableRow>
            )} */}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
